import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { WatcherService } from 'src/app/services/watcher.service';

export interface ShopAndShipAccordionItemInterface {
  title: string;
  content: string;
  isBtn?: boolean;
  buttonText?: string;
  buttonTarget?: string;
  status?: boolean;
}

@Component({
  selector: 'lp-countries-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css'],
})
export class ShopAndShipAccordionComponent implements OnInit {
  @Input() accordionSet: ShopAndShipAccordionItemInterface[];

  lang: string = 'en';
  constructor(
    private _router: Router,
    private watcherService: WatcherService
  ) {}

  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
    this.accordionSet.forEach((item) => (item.status = false));
  }

  goToTarget(target) {
    if(target.includes('/')){
      const targetArr = target.split('/');
      this._router.navigate(['/',targetArr[0], targetArr[1]]);
    } else{
      this._router.navigate(['/',target]);
    }
    
  }
}
